import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface ServicePosition {
    sNr: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    posDoku: boolean;

    updDat?: string;
    updUhr?: number;
    updUser?: string;

    transfer?: boolean;
    transferMenge?: number;
    transferLArt?: string;
}

export interface ServicePositionFilter {
    sNrList?: string[];
    kNr?: number;
    sNr?: string;
    pos?: number;
}

export const defaultServicePosition: ServicePosition = {
    sNr: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: -1, // -1 = new
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 20,
    posBrutto: 0,
    posBem: '',
    posDoku: true,
};

export function useServicePositionList(
    filter: ServicePositionFilter,
    apiOptions?: UseApiOptions<ServicePosition[]>,
): QueryResult<ServicePosition[]> {
    return useApi<ServicePosition[]>(Controller.servicePosition + '/list', { filter }, apiOptions);
}

interface AddServicePositionResult {
    newNr: number;
}

export async function addServicePosition(servicePosition: ServicePosition): Promise<AddServicePositionResult> {
    return callApi<AddServicePositionResult>(Controller.servicePosition + '/add', { servicePosition });
}

export async function updateServicePosition(servicePosition: ServicePosition): Promise<void> {
    return callApi<void>(Controller.servicePosition + '/update', { servicePosition });
}

export async function deleteServicePosition(servicePosition: ServicePosition): Promise<void> {
    return callApi<void>(Controller.servicePosition + '/delete', { servicePosition });
}

export async function moveUpServicePosition(sNr: string, pos: number): Promise<void> {
    return callApi<void>(Controller.servicePosition + '/moveup', {
        servicePosition: {
            sNr,
            pos,
        },
    });
}
